import { Component, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { openDialogGetResult } from 'src/app/helpers/angular-helpers';
import { NewEventDialogComponent } from './dashboard.dialog.newEvent.component';
import { SortOption } from '../../../../globals/store/user.data';
import { UserSettings } from '../../../../globals/store/user.data';
import { Wrapper } from 'src/app/components/wrapper.component';
import { FiltersGroupingUI } from 'globals/store/filters-ui.models';
import { Subject } from 'rxjs';
import { filterPageTypes, filterTypes } from '../../../../globals/store/filters.data';
import { FiltersBarComponent } from 'src/app/components/filters/filters-bar.component';
import { SearchBarComponent } from './../../components/search-bar';
import { filterActions } from 'src/app/store/filters.era';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { IconComponent } from 'src/app/components/icon/icon.component';
import { CommonModule } from '@angular/common';
import { IconTextComponent } from 'src/app/components/buttons/icon-text.component';
import { MatButtonModule } from '@angular/material/button';
import { SortSelectComponent } from './sort-select.component';

@Component({
    selector: 'dashboard-options-bar',
    template: `
<search-bar *ngIf="showSearch" (keyword)="searchKey$.next($event)"></search-bar>
<icon-text class="mobile" filterText="Filter events" [active]="showingFilters || !!filterCount"  (click)="toggleShowFilters($event, !showingFilters)"></icon-text>

<div *ngIf="showFilters" (clickOutside)="toggleShowFilters($event, false, true)"><!-- mobile and desktop must be wrapped within this one directive -->
  <div class="desktop popin-wrapper">
    <icon-text filterText="Filter events" [text]="'Filter events'" [active]="showingFilters || !!filterCount"  (click)="toggleShowFilters($event, !showingFilters)"></icon-text>
    <div class="filters-popin" [ngClass]="{ show: showingFilters, alignLeft: !showSearch }">
      <icon class="close_panel" (click)="showingFilters=false" matIcon="close"></icon>
      <filters-bar [filterGroupings]="filterGroupings" [filterPage]="filterPage"></filters-bar>
    </div>
  </div>
  <div *ngIf="showingFilters" class="mobile mobile-filters" [ngClass]="{ show: showingFilters }">
    <div class="filter_left">
      <icon class="filterIcon" icon="filter_24px"></icon>
      <div class="filter_text">Filter events</div>
    </div>
    <div class="top-right-options">
      <div *ngIf="!!filterCount" class="clear-filters" (click)="$event.stopPropagation(); clearFilters()">Clear filters</div>
      <icon [i18]="true" class="close" (click)="showingFilters=false" matIcon="close"></icon>
    </div>
    <filters-bar [filterGroupings]="filterGroupings" [filterPage]="filterPage"></filters-bar>
    <button matButton="filled" color="primary" (click)="showingFilters=false">DONE</button>
  </div>
</div>

<div style="flex:1"></div>
<sort-select *ngIf="showSortSelect"
  [sortOption]="userSettings"
  (selectSortOption)="saveSorting($event)"
></sort-select>
<mat-checkbox class="desktop" color="primary" [checked]="showClosed" (change)="toggleShowClosedEvents($event)">Show closed events</mat-checkbox>
<button class="new-event-button" matButton="filled" color="primary" (click)="startNewEvent()">New Event</button>
`,
    styleUrls: ['./dashboard-options-bar.scss'],
    imports: [SearchBarComponent, SortSelectComponent, MatButtonModule, FiltersBarComponent, MatCheckboxModule, IconComponent, IconTextComponent, CommonModule],
    standalone: true,
})
export class DashboardOptionsBarComponent extends Wrapper<DashboardOptionsBarComponent> implements OnInit, OnDestroy {
  @Input() showSortSelect: boolean = false
  @Input() showSearch: boolean = false
  @Input() showFilters: boolean = false
  @Input() filterGroupings: FiltersGroupingUI[]
  @ViewChild(FiltersBarComponent) filtersBar: FiltersBarComponent
  @ViewChild(SearchBarComponent) searchBar: SearchBarComponent

  filterPage = filterPageTypes.home

  public showingFilters: boolean = false
  public filterCount: number
  public searchKey$: Subject<string> = new Subject<string>()
  public showClosed = true;
  public userSettings: UserSettings


  ngOnInit() {
    if (this.showSearch) this.subObservableWithDebounce(this.searchKey$, 333, this.dispatchSearch.bind(this))
    this.subProp(this.store.select('filters', 'home', 'count'), 'filterCount')

    this.subProp(this.store.select('settings','user','event_show_closed'), 'showClosed')
    this.subProp(this.store.select('settings','user'), 'userSettings')
  }

  toggleShowFilters(event, open, fromOutside = false) {
    if (event && (!fromOutside || (fromOutside && this.showingFilters))) {
      event.stopPropagation()
    }
    this.showingFilters = open
  }

  dispatchSearch(searchTerm: string) {
    this.store.dispatch(filterActions.updateFilter({
      filterPageType: filterPageTypes.home,
      filterType: filterTypes.search,
      value: searchTerm
    }))
  }

  clearFilters() {
    this.store.dispatch(filterActions.clearFilterGroup(filterPageTypes.home))
    this.filtersBar.clearFilter()
    this.searchBar.clear()
  }

  ngOnDestroy() {
    this.dispatchSearch("") // <== Easiest way to clear out old searches between searches.
  }


  saveSorting(sortOption: SortOption) {
    console.log({ sortOption })
    this.userService.updateSettings({ ...sortOption })
  }

  toggleShowClosedEvents(ev) {
    // this.store.dispatch(new UpdateUserSetting('event_show_closed', ev.checked))
    this.settingsService.saveUserSetting('event_show_closed', ev.checked);
  }

  async startNewEvent() {
    const result = await openDialogGetResult(this.dialog, NewEventDialogComponent, { width: '480px', disableClose: true })
  }
  
}

